import { Tracker, TrackerTypeWithClientId } from '../../models/Tracker';
import { TrackerSettingExtraFieldConfig } from '~/models/TrackerSettingExtraFields';

export class GoogleAds implements TrackerTypeWithClientId {
  id: number = Tracker.TYPE_GOOGLE_ADS;
  label: string = 'Google Ads';
  isEnabled: boolean = true;
  hasClientId: boolean = true;
  isRequireClientId = false;

  getClientIdRegexp(): RegExp {
    return /^AW-[0-9-]+$/i;
  }

  getExtraFields(): TrackerSettingExtraFieldConfig[] {
    return [];
  }
}
